import React from 'react';
import { Box, Stack } from '@mui/material';

import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid';

type Props = {
  showQuickFilter?: boolean;
  showColumnSelector?: boolean;
  showFilterButton?: boolean;
  showDensitySelector?: boolean;

  enableCsvExport?: boolean;
  enablePrintExport?: boolean;

  csvFileName?: string;
  csvDelimiter?: string;
  csvUtf8WithBom?: boolean;
  exportAllColumns?: boolean;

  sx?: any;
};

class FDataGridToolbar extends React.PureComponent<Props> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const showExport =
      this.props.enableCsvExport !== false ||
      this.props.enablePrintExport === true;

    return (
      <GridToolbarContainer
        sx={{
          px: 1,
          py: 0.75,
          gap: 0.5,
          borderBottom: '1px solid',
          borderColor: 'divider',
          justifyContent: 'space-between',
          ...this.props.sx,
        }}
      >
        <Stack
          direction="row"
          spacing={0.5}
          alignItems="center"
          flexWrap="wrap"
        >
          {this.props.showColumnSelector !== false && (
            <GridToolbarColumnsButton />
          )}

          {this.props.showFilterButton !== false && (
            <GridToolbarFilterButton />
          )}

          {this.props.showDensitySelector !== false && (
            <GridToolbarDensitySelector />
          )}

          {showExport && (
            <GridToolbarExport
              csvOptions={{
                disableToolbarButton:
                  this.props.enableCsvExport === false,
                fileName:
                  this.props.csvFileName || 'export',
                delimiter:
                  this.props.csvDelimiter || ',',
                utf8WithBom:
                  this.props.csvUtf8WithBom !== false,
                allColumns:
                  this.props.exportAllColumns === true,
              }}
              printOptions={{
                disableToolbarButton:
                  this.props.enablePrintExport !== true,
              }}
            />
          )}
        </Stack>

        {this.props.showQuickFilter && (
          <Box sx={{ minWidth: { xs: 180, sm: 240 } }}>
            <GridToolbarQuickFilter debounceMs={300} />
          </Box>
        )}
      </GridToolbarContainer>
    );
  }
}

export default FDataGridToolbar;
